/* eslint-disable @typescript-eslint/no-explicit-any */
import { EnvironmentWrapper, SettingsFile } from 'hyarchis-global/environment';
import React, { lazy } from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.scss';

const EnvironmentFile: SettingsFile = {
  filePath: `${process.env.PUBLIC_URL}/${
    process.env.NODE_ENV === 'production' ? '' : 'local.'
  }environment.js`,
  stateKey: 'ENVIRONMENT',
  localStorageKey: 'environment-settings',
};

const root = document.getElementById('root');
const render = (): void => {
  ReactDOM.render(
    <EnvironmentWrapper
      settingsFiles={[EnvironmentFile]}
      component={lazy(() => import('./Main'))}
    />,
    root,
  );
};

if (module.hot) {
  const renderError = (error: any): any => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    const RedBox = require('redbox-react');
    ReactDOM.render(<RedBox error={error} />, root);
  };

  const tryRender = (): void => {
    try {
      render();
    } catch (error) {
      renderError(error);
    }
  };

  (module as any).hot.accept('Main', () => {
    setTimeout(tryRender);
  });
}

render();
